<mat-accordion>
  @for (item of menuItems; track item.name) {
    <!-- Parent items with sub-menus -->
    @if (item.children?.length) {
      <ng-container *hasPermission="{ some: item.requiredPermissions }">
        <mat-expansion-panel class="mat-elevation-z" piniCheckOpen #checkOpen="checkOpen" [expanded]="checkOpen.isOpen">
          <mat-expansion-panel-header>
            @if (item.iconType === 'material' && item.icon) {
              <mat-icon [svgIcon]="item.icon"></mat-icon>
            } @else {
              <i [class]="'icon-size-20 icon-' + item.icon"></i>
            }
            {{ item.name }}
          </mat-expansion-panel-header>

          <pd-nav [menuItems]="item.children || []"/>
        </mat-expansion-panel>
      </ng-container>
    } @else if (shouldShowItem(item)) {
      @if (bypassPermissionCheck(item)) {
        <ng-container *ngTemplateOutlet="menuLink; context: { $implicit: item }"></ng-container>
      } @else {
        <ng-container *hasPermission="{ some: item.requiredPermissions }">
          <ng-container *ngTemplateOutlet="menuLink; context: { $implicit: item }"></ng-container>
        </ng-container>
      }
    }
  }
</mat-accordion>

<!-- Reusable Link Template to eliminate code duplication -->
<ng-template #menuLink let-item>
  <a routerLinkActive
     class="menu-link"
     *feature="item.featureFlagName"
     [routerLink]="item.route"
     [class.active]="isMenuItemActive(item)"
     (click)="logout(item.route)"
     (isActiveChange)="isActiveChange()">
    @if (item.iconType === 'material' && item.icon) {
      <mat-icon [svgIcon]="item.icon" piniSvgIconType="fill"></mat-icon>
    } @else {
      <i [class]="'icon-size-20 icon-' + item.icon"></i>
    }

    {{ item.name }}
  </a>
</ng-template>
